import { Card, Text } from "@portal/components/primitives";

type IndemnitorRowProps = {
	name: string;
	email?: string | null;
};

export const IndemnitorRow = ({ name, email }: IndemnitorRowProps) => (
	<Card elevation="raised" className="flex items-center px-4 py-3">
		<div className="flex items-center flex-1 gap-x-2.5 min-w-0">
			<Text type="body" color="primary" className="[text-box-trim:none]">
				{name}
			</Text>
			{email && (
				<Text type="body-strong" color="tertiary" className="[text-box-trim:none]">
					{email}
				</Text>
			)}
		</div>
	</Card>
);
